import { Component, Input } from '@angular/core';
import { CustomButtonComponent } from "../../../../../shared/components/custom-button/custom-button.component";
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-replace-file-dialog',
  standalone: true,
  imports: [CustomButtonComponent, TranslocoPipe],
  templateUrl: './replace-file-dialog.component.html',
  styleUrl: './replace-file-dialog.component.css'
})
export class ReplaceFileDialogComponent {
  modalDialogId: string = 'fileUpload_modal_replace'
  private replaceFilePromise!: (value: boolean) => void;

  replaceFileNames: string = '';

  openModal(replaceFileNames: string): Promise<boolean> {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    this.replaceFileNames = replaceFileNames;
    
    if (modal) {
      modal.showModal();

      return new Promise<boolean>((resolve) => { this.replaceFilePromise = resolve; });
    }

    return Promise.resolve(false);
  }

  closeModal(replaceFile: boolean): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.close();
      this.replaceFilePromise(replaceFile);
    }
  }
}
